// const URL = 'http://192.168.10.188:8887';
// const URL = 'https://vnapi.festiot.online';
const URL = process.env.VUE_APP_BASE_API;

// const URL = 'http://1.13.18.50:8887';
const prefix = URL + '/sys/company';
const prefix1 =URL + '/sys/bank';
const prefix2 =URL + '/fee';
const prefix3 =URL + '/voucher';
const prefix4 =URL + '/template';
const prefix_flowable =URL + '/flowable';
const prefix_financeAnnex =URL + '/financeAnnex';
const prefix_voucher =URL + '/voucher';
const prefix_exchange =URL + '/sys/exchange';
const prefix_report =URL + '/report';
const prefix_business =URL + '/business';
const prefix_boxFee =URL + '/boxFee';



const url2 = {
    getList: prefix + '/getList',
    saveOrUpdateCustomer: prefix + '/saveOrUpdate',
    getBankList: prefix1 + '/getBankList',
    addBankList:prefix1 + '/addBankList/',
    deleteBank:prefix1 + '/deleteBank',
    getInComeList:prefix2 + '/getInComeList',
    addFee:prefix2 + '/addFee/',
    deleteFee:prefix2 + '/delete',
    wheatherOrNot:prefix2 + '/wheatherOrNot',
    getMyVoucherList:prefix3 + '/getMyVoucherList',
    getBankInfo:prefix3 + '/getBankInfo',
    saveOrUpdateVoucherBase:prefix3 + '/saveOrUpdateVoucherBase/',
    getVoucherHeadById:prefix3 + '/getVoucherHeadById',
    deleteById:prefix3 + '/deleteById',
    getFeeByConditon:prefix3 + '/getFeeByConditon',
    pushVoucherDetail:prefix3 + '/pushVoucherDetail/',
    getVoucherList:prefix3 + '/getVoucherList',
    removeDetailsByIds:prefix3 + '/removeDetailsByIds/',
    getTemplateByName:prefix4 + '/getTemplateByName',
    updateTemplate:prefix4 + '/updateTemplate',
    getDetailById:prefix4 + '/getDetailById',
    deleteTemplate:prefix4 + '/deleteTemplate',
    quickGenerate:prefix3 + '/quickGenerate/',
    quickInsVoucher:prefix3 + '/quickInsVoucher/',
    getHxDetailByVoucherId: prefix3 + '/getHxDetailByVoucherId',
    // signSkRecord: prefix3 + '/signSkRecord/',
    getSkRecords:prefix3 + '/getSkRecords/',
    deleteSkById:prefix3 + '/deleteSkById',
    whetherOrNotMakeSkRecord: prefix3 + '/whetherOrNotMakeSkRecord',
    // 获取全部审批流程
    getFlowableList: prefix_flowable + '/getFlowableList',
    // 启动流程
    startProcess:prefix_flowable + '/startProcess',
    // 我的待审核
    getMyTask:prefix_flowable + '/getMyTask',
    // 通过审批
    finishMyTask:prefix_flowable + '/finishMyTask',
    // 驳回审批
    rejected:prefix_flowable + '/rejected',
    // 查询发起审批时的客户经理
    getManagerByVoucherId:prefix_flowable + '/getManagerByVoucherId',
    // 上传附件
    saveOneAttachment:prefix_financeAnnex + '/saveOneAttachment',
    // 查询是否有上传附件
    getFileListByVoucherId:prefix_financeAnnex + '/getFileListByVoucherId',
    // 填写发票号
    insFPNum:prefix_voucher + '/insFPNum',
    // 查询汇率列表
    getListBy:prefix_exchange + '/getListBy',
    // 新增编辑汇率
    saveOrUpdateExchangeRate:prefix_exchange + '/saveOrUpdateExchangeRate',
    // 获取当日汇率
    getNowRate:prefix_exchange + '/getNowRate',
    // 新增收款台账
    signSkRecord:prefix_voucher + '/signSkRecord',
    // 付费申请将状态改为已付款
    changeFKStatus:prefix_voucher + '/changeFKStatus',
    // 查询双星表单
    doubleStarReport:prefix_report + '/doubleStarReport/',
    // 查询未送达
    deliveryReport:prefix_report + '/deliveryReport',
    // 获取往来单位详细信息
    getById:prefix + '/getById/',
    // 撤回申请
    withdraw:prefix_flowable + '/withdraw',
    // 回款
    business: prefix_business + '/setReceiptStatus/',
    // 单票利润报表
    singleDebitNote:prefix_report + '/singleDebitNote',
    // 单箱利润报表
    singleContainerDebitNote:prefix_report + '/singleContainerDebitNote',
    // 快速录入费用
    quickInsFee:prefix_business + '/quickInsFee',
    // 根据业务id获取附件列表
    getFileListByBusinessId:prefix_financeAnnex + '/getFileListByBusinessId',
    // 修改往来单位的名称
    changeCompanyName:prefix + '/changeCompanyName',
    // 删除主订单
    deleteBusiness:prefix_business + '/deleteBusiness',
    // 删除箱型箱量附件
    deleteAttachmentBy:prefix_business + '/deleteAttachmentBy',
    // 根据提单号查询集装箱信息
    getContainersBy:prefix_boxFee + '/getContainersBy',
    // 创建押箱申请
    applyBoxList:prefix_boxFee + '/applyBoxList',
    // 查询押箱申请
    getBoxFee:prefix_boxFee + '/getBoxFee',
    // 根据名称获取供应商信息
    getSupplyByName:prefix + '/getSupplyByName',
    // 撤回付款申请
    undoVoucher:prefix_flowable + '/undoVoucher',
    // 申请押箱款
    applyBoxFee:prefix_boxFee + '/applyBoxFee',
    // 保存封箱付款申请
    saveBoxFeeApply:prefix_boxFee + '/saveBoxFeeApply',
    // 创建押箱申请
    createBoxFee:prefix_boxFee + '/createBoxFee',
    saveBoxFeeApply:prefix_boxFee + '/saveBoxFeeApply',
    // 申请退押
    applyBackFee:prefix_boxFee + '/applyBackFee',
    // 回款
    confirmBackFee:prefix_boxFee + '/confirmBackFee',
    // 根据流程实例id获取流程状态
    getProcessStatusBy:prefix_flowable + '/getProcessStatusBy',
    // 根据流程实例id判断当前用户是否可以审批
    approvalJudgment:prefix_flowable + '/approvalJudgment',
    // 查询费用凭证
    getFeeVoucher:prefix2 + '/getFeeVoucher',
    // 收款台账认领
    claimSkRecord:prefix_voucher + '/claimSkRecord',
    // 重置认领
    resetSkRecord:prefix_voucher + '/resetSkRecord',
}
export default url2